import { fromJS } from 'immutable';
import * as ReducerActions from './actions';

const initialState = fromJS({
    data: {
        localidades: undefined,
        localidadEdit: undefined
    }
});

export default function localidadesEntregaReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SET_LOCALIDADES_ENTREGA){
        return state.setIn(["data", "localidades"], action.payload);
    }

    if(action.type === ReducerActions.SAVE_LOCALIDAD_ENTREGA){
        return state.setIn(["data", "localidadEdit"], action.payload);
    }

    return state;
}